import { reactive } from 'vue';
import BaseSetupService from '@/setup/BaseSetupService';
import DashboardSignatureBalanceRepartitionAside from '@/components/dashboard/DashboardSignatureBalanceRepartitionAside.vue';
import { useAside } from '@orion.ui/orion';
import { cloneDeep } from 'lodash-es';
import useSignatureBalanceService from '@/services/SignatureBalanceService';

type Props = SetupProps<typeof DashboardSignatureBalanceAlertSetupService.props>

export default class DashboardSignatureBalanceAlertSetupService extends BaseSetupService<Props> {
	static readonly props = undefined;

	private readonly state = reactive({ currentBalancies: [] as ICurrentSignatureBalanceModel[] });


	get lowBalancies () { return this.state.currentBalancies.filter(x => x.balance < x.notificationThreshold);}

	// s'il n'y a aucune balance renvoyé par le back, c'est que l'agence est à la consommation
	get hasPackBilling () { return this.state.currentBalancies.length;}

	constructor (props?: Props) {
		super(props);
	}

	async onBeforeMountAsync () {
		const data = await useSignatureBalanceService().getCurrentSignatureAsync();

		//sanitize interlocutor to avoid null
		data.forEach((x) => {
			if (!x.interlocutor)
				x.interlocutor = '';
		});

		this.state.currentBalancies = data;
	}

	openSignatureBalanceRepartitionAside () {
		useAside({
			Nested: DashboardSignatureBalanceRepartitionAside,
			NestedProps: { balancies: this.state.currentBalancies },
			events: {
				'save': (aside, newBalancies) => {
					this.state.currentBalancies = cloneDeep(newBalancies);
				},
			},
		});
	}
}
